"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sensor32053Bss001LensTable = void 0;
const lens_table_1 = require("../lens-table");
const angle = [
    0.0,
    0.742,
    1.483,
    2.225,
    2.967,
    3.708,
    4.45,
    5.192,
    5.933,
    6.675,
    7.417,
    8.158,
    8.9,
    9.642,
    10.384,
    11.125,
    11.867,
    12.609,
    13.35,
    14.092,
    14.834,
    15.575,
    16.317,
    17.059,
    17.8,
    18.542,
    19.284,
    20.025,
    20.767,
    21.509,
    22.25,
    22.992,
    23.734,
    24.475,
    25.217,
    25.959,
    26.701,
    27.442,
    28.184,
    28.926,
    29.667,
    30.409,
    31.151,
    31.892,
    32.634,
    33.376,
    34.117,
    34.859,
    35.601,
    36.342,
    37.084,
    37.826,
    38.567,
    39.309,
    40.051,
    40.792,
    41.534,
    42.276,
    43.018,
    43.759,
    44.501,
    45.243,
    45.984,
    46.726,
    47.468,
    48.209,
    48.951,
    49.693,
    50.434,
    51.176,
    51.918,
    52.659,
    53.401,
    54.143,
    54.884,
    55.626,
    56.368,
    57.109,
    57.851,
    58.593,
    59.335,
    60.076,
    60.818,
    61.56,
    62.301,
    63.043,
    63.785,
    64.526,
    65.268,
    66.01,
    66.751,
    67.493,
    68.235,
    68.976,
    69.718,
    70.46,
    71.201,
    71.943,
    72.685,
    73.426,
    74.168,
];
const rp /* pixel radius in mm */ = [
    0.0,
    0.048,
    0.095,
    0.143,
    0.19,
    0.238,
    0.286,
    0.333,
    0.381,
    0.428,
    0.476,
    0.523,
    0.571,
    0.618,
    0.665,
    0.713,
    0.76,
    0.807,
    0.854,
    0.901,
    0.948,
    0.995,
    1.042,
    1.089,
    1.135,
    1.182,
    1.228,
    1.275,
    1.321,
    1.367,
    1.413,
    1.459,
    1.505,
    1.551,
    1.596,
    1.641,
    1.687,
    1.732,
    1.777,
    1.822,
    1.866,
    1.911,
    1.955,
    1.999,
    2.043,
    2.087,
    2.13,
    2.173,
    2.216,
    2.259,
    2.302,
    2.344,
    2.386,
    2.428,
    2.47,
    2.511,
    2.552,
    2.593,
    2.634,
    2.674,
    2.714,
    2.754,
    2.793,
    2.832,
    2.871,
    2.909,
    2.948,
    2.985,
    3.023,
    3.06,
    3.096,
    3.132,
    3.168,
    3.204,
    3.239,
    3.273,
    3.308,
    3.341,
    3.375,
    3.408,
    3.44,
    3.472,
    3.504,
    3.535,
    3.565,
    3.595,
    3.625,
    3.654,
    3.682,
    3.71,
    3.738,
    3.765,
    3.791,
    3.817,
    3.842,
    3.866,
    3.89,
    3.914,
    3.936,
    3.959,
    3.98,
];
exports.sensor32053Bss001LensTable = new lens_table_1.LensTable(angle, rp);
